// extracted by mini-css-extract-plugin
export default {"main":"SignUp_main__BzXa8","mainForm":"SignUp_mainForm__o2yl9","form":"SignUp_form__21vFp","bottom":"SignUp_bottom__5GH-4","google":"SignUp_google__gPwLh"};